import { api } from '../../api';

const ObterDadosCNPJ = async (cnpj) => {
  try {
    const response = await api.get('/DadoCadastral/RecuperarCNPJConectaGov', {
      params: { Cnpj: cnpj }
    });

    if (response?.status === 200 || response?.sucesso) {
      const { data } = response;
      // Lida com o caso onde o dado real pode estar encapsulado em uma propriedade 'data'.
      if (data && typeof data === 'object' && 'data' in data) {
        return data.data;
      }
      return data;
    }
    return null;
  } catch (error) {
    console.error("Erro ao recuperar CNPJ:", error);
    return null;
  }
};

const ObterDadosCPF = async (cpf) => {
  try {
    const response = await api.get('/DadoCadastral/RecuperarCPFConectaGov', {
      params: { Cpf: cpf }
    });
    
    if (response?.status === 200 || response?.sucesso) {
      const { data } = response;
      // Lida com o caso onde o dado real pode estar encapsulado em uma propriedade 'data'.
      if (data && typeof data === 'object' && 'data' in data) {
        return data.data;
      }
      return data;
    }
    return null;
  } catch (error) {
    console.error("Erro ao recuperar CPF:", error);
    return null;
  }
};

export {
  ObterDadosCNPJ,
  ObterDadosCPF
};
